module.exports = __webpack_public_path__ + "static/media/user-icon-2.5c9d2013.png";